import { render } from "./GuideMailBind.vue?vue&type=template&id=543b8242"
import script from "./GuideMailBind.vue?vue&type=script&lang=js"
export * from "./GuideMailBind.vue?vue&type=script&lang=js"

import "./GuideMailBind.vue?vue&type=style&index=0&id=543b8242&lang=css"

import exportComponent from "/workspace/goj/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__